export default __webpack_public_path__ + "89eef491116d461b4dc0e68567efa1b7.svg";